import { render, staticRenderFns } from "./chartBarPackageHistory.vue?vue&type=template&id=348e3a20&scoped=true"
import script from "./chartBarPackageHistory.vue?vue&type=script&lang=js"
export * from "./chartBarPackageHistory.vue?vue&type=script&lang=js"
import style0 from "./chartBarPackageHistory.vue?vue&type=style&index=0&id=348e3a20&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348e3a20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348e3a20')) {
      api.createRecord('348e3a20', component.options)
    } else {
      api.reload('348e3a20', component.options)
    }
    module.hot.accept("./chartBarPackageHistory.vue?vue&type=template&id=348e3a20&scoped=true", function () {
      api.rerender('348e3a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/towerControl/dashboard/components/chartBarPackageHistory.vue"
export default component.exports